import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
	name: "date_format",
	standalone: false
})
export class DateFormatPipe implements PipeTransform {
	public transform(
		isoTimestamp: string,
		formatOptions: Intl.DateTimeFormatOptions = { month: "short", year: "numeric" }
	): string {
		const locale = moment.locale();
		const date = new Date(isoTimestamp);

		return date.toLocaleDateString(locale, formatOptions);
	}
}
